export enum ModelEnum {
  'CONTENT',
  'GALLERY',
}
